import { render, staticRenderFns } from "./account-watching.vue?vue&type=template&id=903349b2&scoped=true&"
import script from "./account-watching.vue?vue&type=script&lang=js&"
export * from "./account-watching.vue?vue&type=script&lang=js&"
import style0 from "./account-watching.vue?vue&type=style&index=0&id=903349b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903349b2",
  null
  
)

export default component.exports